import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import CircularProgress from "@mui/material/CircularProgress";
import { getIn, useField, useFormikContext } from "formik";
import { useEffect } from "react";
import { buildArtFieldLabel } from "./artFieldLabelUtils";
import { useArtFieldMetadata } from "./artFieldMetadataContext";

const FormikSelect = ({ caseInsensitive = false, children, loading = false, ...props }) => {
  const [field, meta] = useField(props);
  const { values, setFieldValue } = useFormikContext();
  const fieldValue = getIn(values, props.name);
  const fieldMetadata = useArtFieldMetadata(props.name);
  const label = buildArtFieldLabel(props.label, fieldMetadata);

  useEffect(() => {
    if (props.callBack) {
      props.callBack(fieldValue);
    }
  }, [fieldValue]);

  useEffect(() => {
    if (caseInsensitive) {
      const value = children?.find(
        (child) =>
          child?.props?.value?.toLowerCase() === props.value?.toLowerCase(),
      )?.props.value;

      if (value) setFieldValue(props.name, value);
    }
  }, []);

  const onChange = (value) => {
    setFieldValue(
      props.name,
      value ? (props.returnProp ? value[props.returnProp] : value.id) : value,
    );
    if (props.callBack) {
      props.callBack(value);
    }
  };

  return (
    <FormControl
      sx={props.sx ? { width: "100%", ...props.sx } : { width: "100%" }}
      error={meta.touched && meta.error ? true : false}
      disabled={props.disabled || loading}
      variant={props.variant || "standard"}>
      <InputLabel>{label}</InputLabel>
      <Select
        onChange={(value) => onChange(value.target.value)}
        name={props.name}
        value={props.value}
        variant={props.variant}
        label={label}
        IconComponent={loading ? () => <CircularProgress size={20} sx={{ mr: 1 }} /> : undefined}
        {...field}>
        {children}
      </Select>
      <FormHelperText>
        {meta.touched && meta.error ? meta.error : props.helperText || null}
      </FormHelperText>
    </FormControl>
  );
};

export default FormikSelect;
